/* @flow */
import Button from 'components/Button.jsx';
import LayerTrigger from 'components/LayerTrigger.jsx';
import PropTypes from 'prop-types';
import * as React from 'react';

class MenuButton extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    menu: PropTypes.node.isRequired,
    activeClassName: PropTypes.string,
    tooltip: PropTypes.any,
    tooltipPlacement: PropTypes.any,
    tooltipAlignment: PropTypes.any,
    disabled: PropTypes.bool,
  };

  render() {
    const {
      menu,
      alignment,
      placement,
      activeClassName,
      tooltip,
      tooltipPlacement,
      tooltipAlignment,
      ...other
    } = this.props;

    const button = (
      <Button
        {...other}
        tooltip={tooltip}
        disabled={this.props.disabled}
        tooltipPlacement={tooltipPlacement}
        tooltipAlignment={tooltipAlignment}>
        {this.props.children}
      </Button>
    );

    if (this.props.disabled) {
      return button;
    }

    return (
      <LayerTrigger
        layer={menu}
        trigger="click"
        placement={placement || 'bottom'}
        alignment={alignment || 'left'}
        activeClassName={activeClassName}>
        {button}
      </LayerTrigger>
    );
  }
}

export default MenuButton;
